var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSideBar = function SvgSideBar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.5 16.49c-.48.01-1.03.01-1.667.01H8.167c-2.334 0-3.5 0-4.392-.454a4.167 4.167 0 0 1-1.82-1.821C1.5 13.334 1.5 12.167 1.5 9.833V8.167c0-2.334 0-3.5.454-4.392a4.167 4.167 0 0 1 1.821-1.82C4.666 1.5 5.833 1.5 8.167 1.5h1.666c.637 0 1.186 0 1.667.01m0 14.98c1.283-.024 2.077-.114 2.725-.444a4.167 4.167 0 0 0 1.82-1.821c.455-.891.455-2.058.455-4.392V8.167c0-2.334 0-3.5-.454-4.392a4.167 4.167 0 0 0-1.821-1.82c-.648-.331-1.442-.421-2.725-.446m0 14.982V1.509M5.25 6.5a12.721 12.721 0 0 1 2.434 2.314.295.295 0 0 1 0 .372A12.72 12.72 0 0 1 5.25 11.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSideBar);
export default ForwardRef;